import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from "react-router-dom"; 
import { useSelector, useDispatch } from 'react-redux';
import { AppBar, Toolbar, Typography, Box, TextField, Button, Container, Alert } from '@mui/material';
import { LoadScript, StandaloneSearchBox } from '@react-google-maps/api';

import { GOOGLE_CLIENT_ID, MICROSOFT_CLIENT_ID, LOGIN_REDIRECT_URI, APPID } from '../../common/constants';
import { set } from 'lodash';

import Header from '../../components/Header';

import Social from './components/Social';
import Credentials from './components/Credentials';

import { authActions, userActions } from '../../actions';


const SignIn = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const authState = useSelector(state => state.authReducer); 
  const { user, ...userState } = useSelector((state) => state.userReducer);
  
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [formError, setFormError] = React.useState('');
  const [rememberMe, setRememberMe] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  const handleSso = async ({ provider, data }) => {
    let profile;
    switch (provider) {
      case 'google':
        if (data.sub && data.email && data.name) {
          profile = data;
          profile.id = data.sub;
        } else {
          // try to get profile information with another fetch way
          profile = await authActions.fetchGoogleProfile(data.access_token);
        }
        break;
      case 'microsoft':
        profile = data;
        break;
    }

    let userData = {
      fullName: profile.name,
      email: profile?.email || '',
      provider_id: profile.id,
      provider: provider,
      appId: APPID,
    };

    await handleResponse(userData);
  };

  const handleResponse = async (userData) => {
    setSubmitting(true);
    setFormError('');
    const response = await dispatch(authActions.login(userData));

    if (response?.success === false) {
      setFormError(response?.error || 'Authentication error');
      setSubmitting(false);
    } else if (response === false) {
      setFormError('Authentication error');
      setSubmitting(false);
    }
  }

  const handleSubmit = async () => {
    //console.log('handleSubmit');
    //console.log('***', email, password);
    // event.preventDefault();

    if (!email || !password) {
      // Show error messages or perform necessary actions
      console.log('Please provide your credentials.');
      setFormError('Please provide your credentials.');
      setSubmitting(false);
      return;
    }
    
    const userData = {
      email,
      password,
      appId: APPID,
    };

    await handleResponse(userData);
  }

  useEffect(() => {
    if (authState?.authenticated && user?.userApplicationRoles?.find(app => app.application_id === APPID)) {
      navigate("/app");
    }
    if (authState.error) {
      setFormError(authState.error);
      setSubmitting(false);
    }
  }, [authState]);

  useEffect(() => {
    const handleMessage = (event) => {
      console.log(event.data?.type);
      if (event.data?.type === "AUTH_SUCCESS") {
        dispatch({ type: "SET_AUTH_STATE", payload: { authenticated: true } });
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [dispatch]);


  return (
    <Box sx={{ textAlign: 'center' }}>

        <Typography variant="h5" gutterBottom>
          Sign In
        </Typography>

        <Social
          handleSso={handleSso}
        />

        <Typography variant="h5" mb="15px" gutterBottom>
        - or -
        </Typography>

        <Credentials
          setEmail={setEmail}
          setPassword={setPassword}
          handleSubmit={handleSubmit}
          submitting={submitting}
        />

        <Typography variant="caption" gutterBottom>
          Don't have an Account?{" "}
          <Button
            variant="text"
            color="primary"
            size="small"
            onClick={() => {
              navigate('/sign-up');
            }}
          >
            Sign Up
          </Button>
        </Typography>

        { formError && (
          <Alert severity="error">{formError}</Alert>
        )}

    </Box>
  );
};

export default SignIn;
